module.exports = __webpack_public_path__ + "static/img/dl_M477748_20250213154840.5be442e.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/qrcode/dl_M477748_20250213154840.jpg
// module id = p3zM
// module chunks = 7